import { FormAdditionalFields } from '../../../Form'

import { EntranceAddressField } from './EntranceAddressField'
import { FLAT_FORM_ADDITIONAL_FIELDS_COUNT } from './FlatFormAdditionalFields.constants'
import { NotesField } from './NotesField'
import { PropertyShareField } from './PropertyShareField'
import { RoomTypeField } from './RoomTypeField'

function FlatFormAdditionalFields() {
  return (
    <FormAdditionalFields
      toggleVisibilityProps={{
        itemsCount: FLAT_FORM_ADDITIONAL_FIELDS_COUNT,
        text: 'Flat.ShowAdditionalBtnKey',
      }}
    >
      <EntranceAddressField />
      <RoomTypeField />
      <PropertyShareField />
      <NotesField />
    </FormAdditionalFields>
  )
}

export default FlatFormAdditionalFields
